import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe, setAuthToken as setToken } from './api';

const AuthContext = createContext();

const TOKEN_KEY = 'auth_token';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const initializeAuth = useCallback(async () => {
    try {
      const token = sessionStorage.getItem(TOKEN_KEY);
      if (token) {
        setToken(token);
        const res = await getMe();
        setUser(res.data);
      }
    } catch {
      sessionStorage.removeItem(TOKEN_KEY);
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  const loginUser = useCallback((token, userData) => {
    setToken(token);
    setUser(userData);
  }, []);

  const logoutUser = useCallback(() => {
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
